export default "assets/images/icons/instagram-9b956292.svg";